module.exports = __webpack_public_path__ + "img/serv_sub1_1_m.26f973d1.jpg";